import ImagesSlider from 'assets/core/js/module/imagesSlider'

const initPropertiesSliders = function (): void {
  document.querySelectorAll<HTMLElement>('.aquatic__wrapper .swiper:not(.swiper-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      slidesPerView: 'auto',
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_: undefined, current: number) {
          return `${current}/${el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length}`
        },
      },
      spaceBetween: 0,
    })
  })

  document.querySelectorAll<HTMLElement>('.product__properties-slider .swiper:not(.swiper-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_: undefined, current: number, total: number) {
          return `${current}/${total}`
        },
      },
      spaceBetween: 16,
    })
  })
}

export default function (): void {
  initPropertiesSliders()
}
